/* eslint-disable */
import CTALock from "../../assets/icons/CTALock";
import LeftArrowIcon from "../../assets/icons/LeftArrowIcon";
import RightArrowIcon from "../../assets/icons/RightArrowIcon";
import Thumbnail from "../../assets/img/thumbnail.jpg";
import { TOAST_TYPES } from "../../app/constants";
import { useNotification } from "../../app/context/Notification";
import Bottom from "../Layouts/Bottom";
import VideoItem from "../VerticalPlayer/VideoItem";
import {
  getOptimisticUnlockIds,
  getVideosData,
} from "../VerticalPlayer/helpers";
import useVerticalPlayer from "../VerticalPlayer/hooks/useVerticalPlayer";
import CustomModal from "../common/CustomModal/CustomModal";
import Loader from "../common/Loader";
import LoaderDark from "../common/LoaderDark/LoaderDark";
import "./Series.css";
import gluedin from "gluedin-shorts-js";
import debounce from "lodash.debounce";
import throttle from "lodash.throttle";
import React, {
  createRef,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import { useTranslation } from "react-i18next";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

const SvodModule = new gluedin.GluedInSvodModule();

function Series() {
  const { t } = useTranslation();
  const defaultLanguage = localStorage.getItem("defaultLanguage");
  const contentRoute = localStorage.getItem("contentRoute");
  const { videos, setVideos, currentVideoIndex, setCurrentVideoIndex }: any =
    useVerticalPlayer();
  const [series, setSeries]: any = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const videoRefs: any = useRef<HTMLDivElement | null>(null);
  const [searchParams] = useSearchParams();
  const { seriesId } = useParams();
  const episodeId = searchParams.get("onScreenElementId");
  const { showNotification } = useNotification();
  const offset: any = searchParams.get("offset");
  const limit = 7;
  const verticalPlayerRef = useRef<HTMLDivElement>(null);
  const [page, setPage] = useState(() => {
    const initial = parseInt(offset);
    return Number.isFinite(initial) ? initial : 1;
  });
  const lastScrollTop = useRef(0);
  const [scrollDirection, setScrollDirection] = useState("");
  const totalEpisodes = useRef<number | null>(null);
  const scrollDirectionRef = useRef<"up" | "down" | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const debounceTimer = useRef<NodeJS.Timeout | null>(null);
  const lastPageRequested = useRef<number | null>(null);
  const lastTriggeredScrollDir = useRef<"up" | "down" | null>(null);
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const userPersona = localStorage.getItem("userPersona");
  const hasScrolledToEpisode = useRef(false);
  const location = useLocation();
  const observerRef = useRef<IntersectionObserver | null>(null);

  const extractUnlockId = (entry: any) =>
    entry?.videoId ?? entry?.episodeId ?? entry?.id ?? entry;

  const buildUnlockIdSet = (seriesData: any, responseData?: any) => {
    const responseSource = responseData?.result ?? responseData;
    const responseUnlocks =
      responseSource?.unlockEpisodes ||
      responseSource?.unlockedEpisodes ||
      responseSource?.unlockEpisodeIds ||
      [];
    const seriesUnlocks =
      seriesData?.unlockEpisodes ||
      seriesData?.unlockedEpisodes ||
      seriesData?.unlockEpisodeIds ||
      [];
    const optimisticUnlocks = getOptimisticUnlockIds(seriesId);
    const merged = [
      ...(Array.isArray(responseUnlocks) ? responseUnlocks : []),
      ...(Array.isArray(seriesUnlocks) ? seriesUnlocks : []),
      ...(Array.isArray(optimisticUnlocks) ? optimisticUnlocks : []),
    ];
    const ids = merged
      .map((entry: any) => extractUnlockId(entry))
      .map((value: any) => (value !== undefined && value !== null ? String(value) : ""))
      .filter(Boolean);
    return new Set(ids);
  };

  const buildLockedEpisodePlaceholder = (
    episode: any,
    index: number,
  ) => {
    const episodeId =
      episode?.videoId || episode?.id || episode?._id || `${seriesId}-${index}`;
    const episodeNumber =
      typeof episode?.series?.episode === "number"
        ? episode.series.episode
        : index + 1;

    return {
      ...staticVideoArray,
      isLockedPlaceholder: true,
      isPlaceholder: true,
      videoId: episodeId,
      id: episodeId,
      _id: episodeId,
      series: {
        ...staticVideoArray.series,
        seriesId: seriesId,
        episode: episodeNumber,
        paid: true,
        promo: false,
      },
      paid: true,
      promo: false,
    };
  };
  const staticVideoArray = {
    shareEnabled: true,
    s3Url: "",
    downloadEnabled: true,
    downloadUrl: "",
    taggedUsers: null,
    description: "",
    videoId: "a9f3380c-86cb-4255-9003-365f77f54dc0",
    likeCount: 0,
    soundThumbnail: "",
    title: "",
    soundName: "",
    videoOwnerName: "",
    products: [],
    shareCount: 0,
    artists: [],
    shoppable: false,
    contentType: "video",
    thumbnailUrl: Thumbnail,
    localisedDescription: {
      en: "",
    },
    createdTimestamp: 1748424818007,
    viewsCount: 0,
    commentEnabled: true,
    contentExpiry: 0,
    userId: null,
    commentCount: 0,
    labels: ["iOS"],
    soundId: null,
    topicId: "a9f3380c-86cb-4255-9003-365f77f54dc0",
    contentUrls: [
      {
        duration: 8,
        urls: ["", ""],
        width: 1080,
        type: "video",
        factor: 0.56,
        height: 1920,
      },
    ],
    series: {
      promo: false,
      paid: true,
      episode: 0,
      seriesId: seriesId,
    },
    paid: true,
    user: null,
    categoryId: "iOS",
    likeEnabled: true,
    artistsDetail: [],
    status: "ACTIVE",
    localisedTitle: {
      en: "",
    },
    _id: "a9f3380c-86cb-4255-9003-365f77f54dc0",
  };

  useEffect(() => {
    if (!episodeId || !videos?.length || hasScrolledToEpisode.current) return;

    const clickedVideoElement = document.getElementById(
      `content-video-${episodeId}`
    );
    if (clickedVideoElement) {
      clickedVideoElement.scrollIntoView({
        behavior: "auto",
        block: "center",
      });
      const targetIndex = videos.findIndex((item: any) => {
        const candidate = item?.videoId ?? item?.id ?? item?._id;
        return String(candidate) === String(episodeId);
      });

      if (targetIndex >= 0) {
        setCurrentVideoIndex(targetIndex);
        const targetRef = videoRefs?.current?.[targetIndex]?.current;
        if (targetRef) {
          const attemptAutoplay = async () => {
            try {
              await targetRef.play();
            } catch (error: any) {
              if (error?.name === "NotAllowedError") {
                targetRef.muted = true;
                try {
                  await targetRef.play();
                } catch {}
              }
            }
          };
          setTimeout(attemptAutoplay, 200);
        }
      }
      hasScrolledToEpisode.current = true;
    }
  }, [episodeId, videos.length]);

  const loginModalHandler = () => {
    setShowLoginModal(true);
  };

  const goBack = () => {
    window.history.back();
  };

  const fetchSeriesDefinition = useCallback(async () => {
    try {
      const seriesDefinitionResponse = await SvodModule.getSeriesDefinitionById({
        seriesId: seriesId,
      });
      if (seriesDefinitionResponse?.data?.success) {
        const Series = seriesDefinitionResponse?.data?.result;
        setSeries(Series);
        return Series;
      }
    } catch (error) {
      console.log("Error", error);
    }
    return null;
  }, [seriesId]);

  const fetchSeriesEpisodes = useCallback(
    async ({
      seriesOverride,
      pageOverride,
      showLoader = true,
    }: {
      seriesOverride?: any;
      pageOverride?: number;
      showLoader?: boolean;
    } = {}) => {
      const resolvedSeries = seriesOverride ?? series;
      const pageCandidate =
        typeof pageOverride === "number" ? pageOverride : page;
      const resolvedPage = Number.isFinite(pageCandidate) ? pageCandidate : 1;

      if (!resolvedSeries) {
        return;
      }

      if (showLoader) {
        setIsLoading(true);
      }

      try {
        const promoEpisode = Array.isArray(resolvedSeries?.episodes)
          ? resolvedSeries.episodes.find((episode: any) => episode?.promo === true)
          : null;
        const promoEpisodeId =
          promoEpisode?.videoId ??
          promoEpisode?.episodeId ??
          promoEpisode?.id ??
          promoEpisode?.topicId ??
          promoEpisode?._id;

        const seriesEpisodesResponse = await SvodModule.getSeriesEpisodesById({
          seriesId: seriesId,
          offset: resolvedPage,
          limit: limit,
          ...(promoEpisodeId && {
            promoVideoId: promoEpisodeId,
          }),
        });
        if (seriesEpisodesResponse?.data?.success) {
          const seriesEpisodes = seriesEpisodesResponse?.data?.result;
          const unlockIds = buildUnlockIdSet(
            resolvedSeries,
            seriesEpisodesResponse?.data
          );
          totalEpisodes.current = seriesEpisodesResponse?.data?.total ?? 0;

          let seriesVideos = seriesEpisodes;
          const isPersonaMismatch =
            (userPersona &&
              userPersona !== resolvedSeries?.persona?.[userPersona]?.key) ||
            !userPersona;

          if (isPersonaMismatch) {
            const hasPersona =
              resolvedSeries &&
              Object.prototype.hasOwnProperty.call(resolvedSeries, "persona");
            const hasCta =
              resolvedSeries &&
              Object.prototype.hasOwnProperty.call(resolvedSeries, "cta");

            const personaObj = resolvedSeries?.persona || {};
            const ctaObj = resolvedSeries?.cta || {};

            const isPersonaEmpty =
              !hasPersona || Object.keys(personaObj).length === 0;
            const isCtaEmpty = !hasCta || Object.keys(ctaObj).length === 0;

            const shouldShowLockedPlaceholders =
              (userPersona &&
                resolvedSeries?.paid &&
                // Case 1: Both persona and cta are missing or empty — should NOT execute
                !(isPersonaEmpty && isCtaEmpty) &&
                // Case 2: userPersona key not in persona AND not in cta, but both objects are non-empty
                ((!personaObj[userPersona] && !ctaObj[userPersona]) ||
                  // Case 3: userPersona not in persona BUT present in cta
                  (!personaObj[userPersona] && ctaObj[userPersona]) ||
                  // Case 4: userPersona in both but doesn't match persona key (strict mismatch)
                  (personaObj[userPersona] &&
                    userPersona !== personaObj[userPersona]?.key))) ||
              (!userPersona && resolvedSeries?.paid);

            if (shouldShowLockedPlaceholders) {
              const nextVideos: any[] = [];
              let placeholderAdded = false;

              seriesEpisodes.forEach((episode: any, index: number) => {
                if (placeholderAdded) {
                  return;
                }
                const episodeId = extractUnlockId(episode);
                const isUnlocked =
                  episodeId && unlockIds.has(String(episodeId));
                const isFree =
                  episode?.promo === true || episode?.series?.paid === false;

                if (isUnlocked || isFree) {
                  nextVideos.push(episode);
                  return;
                }

                nextVideos.push(buildLockedEpisodePlaceholder(episode, index));
                placeholderAdded = true;
              });

              seriesVideos = nextVideos;
            } else {
              seriesVideos = seriesEpisodes.filter((episode: any) => {
                const episodeId = extractUnlockId(episode);
                const isUnlocked =
                  episodeId && unlockIds.has(String(episodeId));
                const isFree =
                  episode?.promo === true || episode?.series?.paid === false;
                return isUnlocked || isFree;
              });
            }
          }

          const videosData = getVideosData(seriesVideos);
          videoRefs.current = [
            ...videosData.map(() => createRef<HTMLVideoElement>()),
          ];

          setVideos(videosData);
        } else {
          showNotification({
            title: "Series",
            subTitle: "Server error! please try again",
            type: TOAST_TYPES.ERROR,
          });
        }
      } catch (error) {
        console.log("Error", error);
      }

      if (showLoader) {
        setIsLoading(false);
      }
    },
    [
      contentRoute,
      page,
      series,
      seriesId,
      limit,
      showNotification,
      userPersona,
    ]
  );

  const refreshSeriesAfterUnlock = useCallback(async () => {
    const updatedSeries = await fetchSeriesDefinition();
    await fetchSeriesEpisodes({
      seriesOverride: updatedSeries ?? series,
      showLoader: false,
    });
    return updatedSeries;
  }, [fetchSeriesDefinition, fetchSeriesEpisodes, series]);

  useEffect(() => {
    const newPage = parseInt(offset);
    setPage(Number.isFinite(newPage) ? newPage : 1);
  }, [offset]);

  useEffect(() => {
    fetchSeriesDefinition();
  }, [fetchSeriesDefinition]);

  useEffect(() => {
    fetchSeriesEpisodes();
  }, [fetchSeriesEpisodes]);

  useEffect(() => {
    const container = verticalPlayerRef.current;
    if (!container) return;

    const debounceDelay = 100;
    const scrollThreshold = 2500;
    const debounceTimer = {
      current: null as null | ReturnType<typeof setTimeout>,
    };

    const handleScroll = () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }

      debounceTimer.current = setTimeout(() => {
        const scrollTop = container.scrollTop;
        const scrollHeight = container.scrollHeight;
        const clientHeight = container.clientHeight;

        const isScrollingDown = scrollTop > lastScrollTop.current;
        const isScrollingUp = scrollTop < lastScrollTop.current;

        // Save current scroll position
        lastScrollTop.current = scrollTop;

        const currentVideoElement =
          videoRefs?.current?.[currentVideoIndex]?.current;
        const currentVideoData = videos?.[currentVideoIndex];

        if (currentVideoData?.paid && series?.paid) {
          const isPersonaMismatch =
            userPersona && userPersona !== series?.persona?.[userPersona]?.key;

          const isPersona = !userPersona;

          if (isPersonaMismatch || isPersona) {
            setShowPopup(true);
            return;
          }
        } else {
          setShowPopup(false);
        }

        // Down Scroll (Load Next Content)
        if (
          scrollTop + clientHeight >= scrollHeight - scrollThreshold &&
          totalEpisodes.current !== null &&
          page < totalEpisodes.current - 3 &&
          currentVideoIndex > videos.length - 2
        ) {
          setPage((prev) => prev + 1);
        }

        // Up Scroll (Load previous content)
        if (scrollTop <= scrollThreshold && page > 0) {
          setPage((prev) => prev - 1);
        }
      }, debounceDelay);
    };

    container.addEventListener("scroll", handleScroll);
    return () => {
      container.removeEventListener("scroll", handleScroll);
      if (debounceTimer.current) clearTimeout(debounceTimer.current);
    };
  }, [currentVideoIndex, videos.length]);

  return (
    <div className="series-container">
      {isLoading && <Loader />}
      <div className="full-sec"><div className="mid-content series-content">
          <div
            ref={verticalPlayerRef}
            id="vertical-player"
            className="player_wrapper"
          >
            <div className="profile-head-back">
              <div className="back-btn">
                <button className="back-btn-a" onClick={goBack}>
                  {defaultLanguage === "en" ? (
                    <LeftArrowIcon />
                  ) : (
                    <RightArrowIcon />
                  )}
                  {t("back-btn")}
                </button>
              </div>
            </div>

            {videos?.map((video: any, index: number) => (
              <VideoItem
                key={video?.videoId}
                ref={videoRefs?.current[index]}
                video={video}
                setVideos={setVideos}
                setCurrentVideoIndex={setCurrentVideoIndex}
                totalEpisodesCount={totalEpisodes.current}
                seriesDefinition={series}
                onEpisodeUnlock={refreshSeriesAfterUnlock}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Series;
